import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { MedTemplateDirective, NgClassType } from "@mk/med-ui";

import { DEFAULT_POSITION, NOTIFICATION_LIFE_TIME } from "./constants";
import { MedNotificationCloseEvent } from "./typesLocal";
import { MedNotificationService } from "./med-notification.service";
import { MedNotification, MedNotificationPositions } from "./types";

@Component({
  selector: "med-notification",
  templateUrl: "./med-notification.component.html",
  styleUrls: ["./med-notification.component.scss"],
})
export class MedNotificationComponent implements OnInit, AfterContentInit, OnDestroy {
  constructor(
    private notification: MedNotificationService,
    private cd: ChangeDetectorRef,
  ) {
  }

  @Input() key?: string;
  @Input() position: MedNotificationPositions = DEFAULT_POSITION;
  @Input() lifeTime: number = NOTIFICATION_LIFE_TIME;
  @Input() closable = false;

  @Output() close: EventEmitter<MedNotification> = new EventEmitter();

  @ContentChildren(MedTemplateDirective) templates!: QueryList<any>;

  list: MedNotification[] = [];
  template!: TemplateRef<any>;
  clearSubscription!: Subscription;
  notificationSubscription!: Subscription;

  @HostBinding("class") get class(): NgClassType {
    return ["med-notification", this.position];
  }

  ngOnInit(): void {
    this.notificationSubscription = this.notification.list.subscribe(data => {
      const notifications = data.filter(m => this._canAdd(m));

      if (!notifications.length) {
        return;
      }

      this._add(notifications);
    });

    this.clearSubscription = this.notification.clearList.subscribe(key => {
      if (!key || this.key === key) {
        this.list = [];
      }

      this.cd.markForCheck();
    });
  }

  ngAfterContentInit() {
    this.templates.forEach(item => {
      this.template = item.template;
    });
  }

  ngOnDestroy() {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }

    if (this.clearSubscription) {
      this.clearSubscription.unsubscribe();
    }
  }

  onNotificationClose(event: MedNotificationCloseEvent) {
    this.list.splice(event.index, 1);
    this.close.emit(event.notification);
    this.cd.detectChanges();
  }

  private _canAdd({ key }: MedNotification): boolean {
    return this.key === key;
  }

  private _add(list: MedNotification[]): void {
    this.list = this.list.concat(list);
    this.cd.markForCheck();
  }
}
